/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-debugger */
import { useState, useEffect } from 'react';
import { Card, Container } from '@material-ui/core';
import useSettings from 'src/hooks/useSettings';
import TableSearch from 'src/components/table/TableSearch';
import { CATEGORY_FILE_LIST_HEAD } from 'src/constants/Dashboard';
import { useSnackbar } from 'notistack5';
import {
  filterCategory,
  deleteFileCategory,
  statusChange,
  resetCategoryMsg,
  resetCreateFileCategoryStatus
} from 'src/redux/slices/filecategory';
import { useDispatch, useSelector } from 'src/redux/store';
import AlertDialog from 'src/components/common-components/AlertDialog';

export default function FileCategoryList({
  setEditId,
  deleteId,
  setDeleteId,
  fileCategoryList,
  categoryFileListStatus,
  setCategoryFileListStatus,
  loading
}) {
  const { themeStretch } = useSettings();
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const [close, setClose] = useState(false);
  const [title, setTiltle] = useState('');
  const [content, setContent] = useState('');
  const dispatch = useDispatch();
  const { createCategoryStatus, categoryMsg } = useSelector((state) => state.filecategory);

  useEffect(() => {
    if (createCategoryStatus) {
      enqueueSnackbar('File Type Disabled Successfully', { variant: 'success' });
      dispatch(resetCreateFileCategoryStatus());
    }
    if (categoryMsg) {
      setClose(true);
      setOpen(true);
      dispatch(resetCategoryMsg());
      setTiltle('Disable File Type');
      setContent(categoryMsg);
    }
  }, [categoryMsg, createCategoryStatus]);

  const handleFileCategoryListSwitch = (e) => {
    setCategoryFileListStatus(!e.target.checked);
  };

  const handleDelete = (id) => {
    setClose(false);
    setTiltle('Delete File Type?');
    setContent('Are you sure want to delete File Type permanently??');
    setOpen(true);
    setDeleteId(id);
  };

  const handleDeleteDispatch = () => {
    dispatch(deleteFileCategory(deleteId));
    enqueueSnackbar('File Type Deleted Successfully', {
      variant: 'success'
    });
    setOpen(false);
  };

  const handleDisable = async (id) => {
    dispatch(statusChange(id, false));
  };

  const handleRestore = async (id) => {
    dispatch(statusChange(id, true));
    enqueueSnackbar('File Type Restore Successfully', {
      variant: 'success'
    });
  };

  const handleEdit = (id) => {
    setEditId(id);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Container maxWidth={themeStretch ? false : 'lg'} style={{ padding: 0 }}>
      <Card>
        <AlertDialog
          title={title}
          content={content}
          okFunction={close ? handleClose : handleDeleteDispatch}
          open={open}
          setOpen={setOpen}
        />
        <TableSearch
          tableHead={CATEGORY_FILE_LIST_HEAD}
          tableData={fileCategoryList}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          handleDisable={handleDisable}
          handleRestore={handleRestore}
          status={categoryFileListStatus}
          switchButton
          filterComponent={filterCategory}
          switchButtonResponse={handleFileCategoryListSwitch}
          loading={loading}
        />
      </Card>
    </Container>
  );
}
